export default __webpack_public_path__ + "static/media/key.507fe7a9.svg";